import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  modalPaper: {
    margin: 'auto',
    width: 1000,
    padding: '1px 24px 24px 24px',
    marginTop: '5vh',
    outline: 'none',
    overflowX: 'auto',
    overflowY: 'auto',
    backgroundColor: theme.palette.background.default
  },
  contentTitlesHeader: {
    marginTop: 45
  },

  contentInfoContainerWrapper: {
    marginTop: 20
  },
  contentInfoContainer: {
    maxHeight: 550,
    overflowY: 'auto'
  }
}))

export default useStyles
